const MILLISECONDS_IN_SECONDS = 1000;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

export const getDateDifferenceInDays = ({
  endDate,
  startDate,
}: {
  endDate: Date;
  startDate: Date;
}): number => {
  const differenceInTime = endDate.getTime() - startDate.getTime();

  return (
    Math.floor(
      differenceInTime /
        (MILLISECONDS_IN_SECONDS * MINUTES_IN_HOUR * SECONDS_IN_MINUTE * HOURS_IN_DAY)
    ) + 1
  );
};
